import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IRestaurantStore,
} from '../../mobx-store/storeInterfaces/restaurantInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import { languageCodes } from '../../constants/languages';

interface IProps extends WithSnackbarProps {
  restaurantStore: IRestaurantStore;
  countryStore: CountryStore;
  history: any;
}

@inject('restaurantStore')
@inject('countryStore')
@observer
class Restaurants extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  constructor(props: IProps) {
    super(props);
    this.title = translate('restaurantsListPageTitle', {
    });
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.restaurantStore.updateRestaurantStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/restaurants/${this.props.restaurantStore.restaurantsList[index].restaurantId}/edit`);
  };

  handleTableMenuButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/restaurants/${this.props.restaurantStore.restaurantsList[index].restaurantId}/categories`);
  };

  handelAdd = (): void => {
    this.props.history.push('/restaurants/new');
  };

  getAddRestaurantButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: this.handelAdd,
  });

  getRestaurantTableHeader = () => [
    {
      title: translate('restaurantsListRestaurantColumnTitle', {
      }),
    },
    {
      title: translate('restaurantsListStatusColumnTitle', {
      }),
    },
    {
      title: translate('restaurantsListEditColumnMenu', {
      }),
    },
    {
      title: translate('restaurantsListEditColumnTitle', {
      }),
    },
    {
      title: translate('bulkSeed', {
      }),
    },
  ];

  getRestaurantTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('restaurantsListStatusActive', {
      }),
      inactiveLabel: translate('restaurantsListStatusInactive', {
      }),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'menu',
      onClick: this.handleTableMenuButtonCellClicked,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
    {
      cellType: 'Button',
      key: 'bulk',
      onClick: this.handleBulkSeed,
    },
  ];

  handleBulkSeed = (index: number) => {
    this.props.history.push(`/restaurants/${this.props.restaurantStore.restaurantsList[index].restaurantId}/bulk`);
  }

  handleSearchChanged = (title: any) => {
    const {
      countryStore, restaurantStore,
    } = this.props;
    restaurantStore.filterRestaurants(title, countryStore.managedCountries, languageCodes.english);
  };

  handleClearSearch = () => {
    const {
      countryStore, restaurantStore,
    } = this.props;
    restaurantStore.getRestaurants(countryStore.managedCountries, languageCodes.english);
  };

  render() {
    this.addButton = this.getAddRestaurantButton();
    this.tableHeader = this.getRestaurantTableHeader();
    this.tableCellTypes = this.getRestaurantTableCellTypes();
    return (
      <div>
        <GeneralSearchComponent
          onSearchClick={this.handleSearchChanged}
          searchBy="title"
          onClearSearch={this.handleClearSearch}
        />
        <GeneralTableComponent
          emptyMessage={translate('restaurantsListNoRestaurantsMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.props.restaurantStore.restaurantsList}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.restaurantStore.getRestaurantsRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, restaurantStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    restaurantStore.getRestaurants(countryStore.managedCountries, languageCodes.english);
  }
}

export default Restaurants;
